export default "__VITE_ASSET____TEi17h__"